import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const DeviceSignals = ProtectedJsonAPI.extend(
  '/auto_dr/device_signals',
  {
    index:   endpoint => endpoint
  }
)